import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './TakeawayCheckoutModal.css';

const TakeawayCheckoutModal = ({ isOpen, onClose, onConfirm, loading }) => {
    const { t } = useTranslation();
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        notes: ''
    });
    const [errors, setErrors] = useState({});

    if (!isOpen) return null;

    const validate = () => {
        const newErrors = {};
        if (!formData.name.trim()) newErrors.name = t('common.required');
        if (!formData.phone.trim()) newErrors.phone = t('common.required');
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validate()) {
            onConfirm({ ...formData, dataConsent: true });
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content takeaway-modal">
                <div className="modal-header">
                    <h2>{t('takeaway.checkoutTitle')}</h2>
                    <button className="close-button" onClick={onClose} disabled={loading}>×</button>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="modal-body">
                        <p className="modal-description">{t('takeaway.checkoutDescription')}</p>

                        <div className="form-group">
                            <label>{t('common.name')} *</label>
                            <input
                                type="text"
                                value={formData.name}
                                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                                placeholder={t('takeaway.namePlaceholder')}
                                className={errors.name ? 'error-input' : ''}
                                disabled={loading}
                            />
                            {errors.name && <span className="error-text">{errors.name}</span>}
                        </div>

                        <div className="form-group">
                            <label>{t('auth.email')}</label>
                            <input
                                type="email"
                                value={formData.email}
                                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                                placeholder={t('takeaway.emailPlaceholder')}
                                disabled={loading}
                            />
                        </div>

                        <div className="form-group">
                            <label>{t('common.phone')} *</label>
                            <input
                                type="tel"
                                value={formData.phone}
                                onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                                placeholder={t('takeaway.phonePlaceholder')}
                                className={errors.phone ? 'error-input' : ''}
                                disabled={loading}
                            />
                            {errors.phone && <span className="error-text">{errors.phone}</span>}
                        </div>

                        <div className="form-group">
                            <label>{t('common.notes')}</label>
                            <textarea
                                value={formData.notes}
                                onChange={(e) => setFormData({ ...formData, notes: e.target.value })}
                                placeholder={t('takeaway.notesPlaceholder')}
                                disabled={loading}
                                rows={3}
                            />
                        </div>
                    </div>

                    <div className="modal-actions">
                        <button type="button" className="btn btn-secondary" onClick={onClose} disabled={loading}>
                            {t('common.cancel')}
                        </button>
                        <button type="submit" className="btn btn-primary" disabled={loading}>
                            {loading ? t('common.loading') : t('cart.placeOrder')}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default TakeawayCheckoutModal;
